// extracted by mini-css-extract-plugin
export default {"container":"WhatsappFloatButton_container__dDb0e","button":"WhatsappFloatButton_button__x7pnq","icon":"WhatsappFloatButton_icon__jrH+B"};